import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';
import { setupNavigation } from "../../redux/actions/navItemsActions"
import { loadEvent, editEvent, cancelEvent, deleteEvent, updateUserParticipation } from "../../redux/actions/eventActions";
import { loadGroup } from "../../redux/actions/groupActions";
import EventForm from "./EventForm";
import EventCancellationForm from "./EventCancellationForm";
import EventParticipationControl from "./EventParticipationControl";
import PostFeedControl from "../postComments/PostFeedControl";
import Spinner from "../common/Spinner";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import { toast } from "react-toastify";
import $ from 'jquery';
import "./Event.css";
import moment from "moment";


function EventPage({
    setupNavigation,
    loadEvent,
    editEvent,
    cancelEvent,
    deleteEvent,
    updateUserParticipation,
    loadGroup,
    eventId,
    events, 
    groups,
    user,
    history,
    ...props
}) {

    const [processing, setProcessing] = useState(true);
    const [errors, setErrors] = useState({});
    const [event, setEvent] = useState(null);
    const [eventDetails, setEventDetails] = useState({ name: "", location: "", description: "", routeId: null, route: null, startDate: new Date(), finishDate: new Date() });
    const [group, setGroup] = useState(null);
    const [viewerParticipationStatus, setViewerParticipationStatus] = useState(4);
    const [participationDetails, setParticipationDetails] = useState({});
   
    const navigationItems =
    {
        sections: [
        {
            name: 'Administration',
            items: [
                /*
                {
                    func: onDuplicateEvent,
                    text: 'Duplicate Event',
                    icon: 'fa-copy'
                }
                */
            ]
        }]
    };


    useEffect(() => {
        document.title = "Event | JustGoRide";
        var eventLoaded = false; 
        if (events) {
            events.map(event => {
                if (event.id == eventId && event.fullyLoaded) {
                    setUpEvent(event)
                    setAccess(event);
                    setupNavigation(navigationItems);
                    eventLoaded = true;
                }
            })
        }

        if (!eventLoaded) {
            reloadEvent()
        }
        else {
            setProcessing(false);
        }
        
    }, [eventId]);

    useEffect(() => {
        if (events) {
            events.map(event => {
                if (event.id == eventId) {
                    setUpEvent(event);
                }
            })
        }
    }, [events, groups])

    useEffect(() => {
        if (group) {
            if (!userHasAccess()) {
                history.push("/resourceunavailable");
            }
        }
    }, [group])

    useEffect(() => {
        if (props.location.state && props.location.state.source == "notifications") {
            setProcessing(true);
            reloadEvent()
        }
    }, [props.location])

    function reloadEvent() {
        loadEvent(eventId)
            .then((e) => {
                setUpEvent(e)
                setAccess(e);
                setupNavigation(navigationItems);
                setProcessing(false);
            })
            .catch(error => {
                if (error.message === "401" || error.message === "404") {
                    history.push("/resourceunavailable");
                    return;
                }
                console.error("Loading event failed: " + error);
                history.push("/oops");
            });
    }

    function setUpEvent(event) {
        if (event.fullyLoaded) {
            loadGroupDetails(event.groupId)
            event.startDate = new Date(event.startDate);
            event.finishDate = new Date(event.finishDate);
            event.routeId = event.routes[0].id;
            event.route = { id: event.routes[0].id, name: event.routes[0].name }
            if (event.cancellationReason == null) {
                event.cancellationReason = "";
            }
            setEvent(event);
            setEventDetails(event);
            setPartcipationStatus(event);

            document.title = `${event.name} | JustGoRide`;
        } else {
            setProcessing(true);
            reloadEvent();
        }
    }

    function setPartcipationStatus(event) {
        var going = [];
        var maybe = [];
        var cant = [];
        event.participants.map(p => {
            if (p.userId.toUpperCase() == user.id.toUpperCase()) {
                setViewerParticipationStatus(p.status);
            }
            if(p.status == 0) going.push(p);
            if(p.status == 1) maybe.push(p);
            if(p.status == 2) cant.push(p);
        })
        setParticipationDetails({ going: going, maybe: maybe, cantgo: cant });
    }

    function setAccess(event) {
        if (event.organiser.userId.toUpperCase() == user.id.toUpperCase()) {

            navigationItems.sections[0].items.push(
                {
                    func: onEditEvent,
                    text: 'Edit Event',
                    icon: 'fas fa-edit'
                }
            )

            navigationItems.sections[0].items.push(
                {
                    func: onConfirmCancelEvent,
                    text: event.cancelled ? 'Update Cancellation' :'Cancel Event',
                    icon: 'fas fa-window-close'
                }
            )

            navigationItems.sections[0].items.push(
                {
                    func: onConfirmDeleteEvent,
                    text: 'Delete Event',
                    icon: 'fas fa-trash-alt'
                }
            )
        }
    }

    function loadGroupDetails(groupId) {
        if (group == null || group.administrators.length === 0) {
            loadGroup(groupId)
                .then((g) => {
                    setGroup(g);
                    setProcessing(false);
                })
        }
        else {
            setProcessing(false);
        }
    }

    function userHasAccess() {
        var userOk = false;
        group.administrators.map(a => {
            if (a.userId.toUpperCase() == user.id.toUpperCase()) {
                userOk = true;
            }
        })
        if (userOk) return true;
        group.members.map(m => {
            if (m.userId.toUpperCase() == user.id.toUpperCase()) {
                userOk = true; 
            }
        })
        return userOk;
    }

    function onDuplicateEvent(e) {
        e.preventDefault()
        alert('COPY');
    }

    function onEditEvent(e) {
        e.preventDefault()
        $('#editEvent').modal('show');
    }

    function onConfirmCancelEvent(e) {
        e.preventDefault()
        $('#confirmCancelEvent').modal('show');
    }

    function onConfirmDeleteEvent(e) {
        e.preventDefault()
        $('#confirmDeleteEvent').modal('show');
    }

    function handleCloseConfirmCancel(e) {
        e.preventDefault()
        $('#confirmCancelEvent').modal('hide');
    }

    function handleCancelEvent(e) {
        e.preventDefault()
        $('#confirmCancelEvent').modal('hide')
        setProcessing(true);

        cancelEvent(eventDetails.id, eventDetails.cancellationReason)
            .then(() => {
                setProcessing(false);
                toast.success(`Event Cancelled`);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to cancel event: ${error.message}`);
            });

    }

    function onDeleteEvent(e) {
        e.preventDefault()
        $('#confirmDeleteEvent').modal('hide')
        setProcessing(true);
        var groupId = event.groupId; 
        deleteEvent(event.id)
            .then(() => {
                toast.success(`Event Deleted`);
                history.push(`/groups/${groupId}`);;
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to delete event: ${error.message}`);
            });
    }

    function handleChange(e) {
        var { name, value } = e.target;

        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: null
        }))

        if (name == "routeId") {
            setEventDetails(prevEventDetails => ({
                ...prevEventDetails,
                route: { id: value, name: getRouteName(value) },
                routeId: value
            }));
            return; 
        }

        setEventDetails(prevEventDetails => ({
            ...prevEventDetails,
            [name]: value
        }));
    }

    function handleSave(e) {
        e.preventDefault();

        if (!formIsValid()) {
            return;
        }

        $('#editEvent').modal('hide')
        setProcessing(true);

        editEvent(eventDetails)
            .then(() => {
                setProcessing(false);
                toast.success(`Event Updated`);
            })
            .catch(error => {
                setProcessing(false);
                $('#editEvent').modal('show')
                setErrors({ onSave: error.message });
            });
    }

    function formIsValid() {
        const errors = {};
        var isValid = true;

        if (!eventDetails.name) {
            errors.name = "An event title is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!eventDetails.location) {
            errors.location = "A location is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!eventDetails.description) {
            errors.description = "A description is required.";
            setErrors(errors);
            isValid = false;
        }

        if (!moment(eventDetails.finishDate).isSameOrAfter(eventDetails.startDate)) {
            errors.finishDate = "End date must be after the start date!";
            setErrors(errors);
            isValid = false;
        }
        return isValid;
    }

    function handleCancelSave(e) {
        e.preventDefault();
        $('#editEvent').modal('hide');
    }

    function handleSetStaus(e) {
        e.preventDefault();
        setProcessing(true);
        var status = e.target.value;
        var updatedUser = {
            firstName: user.firstName, surname: user.surname, userId: user.id, hasAvatar: user.avatarAvailable
        }
        updateUserParticipation(event.id, updatedUser, status)
            .then(() => {
                setProcessing(false);
                setViewerParticipationStatus(status)
                toast.success(`Response updated`);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to record response: ${error.message}`);
            });
    }

    function getRoutes() {

        var routeChoice = [];

        if (group.sharedRoutes) {
            group.sharedRoutes.map(route => {
                routeChoice.push({ value: route.routeId, text: route.routeName })
            })
        }

        return routeChoice;
    }

    function getRouteName(id) {
        var name; 
        if (group.sharedRoutes) {
            group.sharedRoutes.map(route => {
                if (route.routeId == id) name = route.routeName
            })
        }
        return name;
    }

    function getRouteCategoryBadge(category) {
        switch (category) {
            case "Road":
                return "/resources/images/road75.png";
            case "OffRoad":
                return "/resources/images/mtb75.png";
            case "Gravel":
                return "/resources/images/gravel75.png";
            default:
                return "/resources/images/road75.png"
        }
    }

    function getRouteDistance(){
        var distance = (user && user.preferredMeasurementUnits === 'Statute'
            ? (event.routes[0].distance * 0.621371192).toFixed(2)
            : event.routes[0].distance.toFixed(2));

        var unit = (user && user.preferredMeasurementUnits === 'Statute' ? 'mi' : 'km')
        return `${distance} ${unit}`
    }

    function getRouteElevation() {
        var elevation = (user && user.preferredMeasurementUnits == 'Statute'
            ? (event.routes[0].elevation * 3.2808399).toFixed(0)
            : event.routes[0].elevation.toFixed(0));

        var unit = (user && user.preferredMeasurementUnits === 'Statute' ? 'ft' : 'm')
        return `${elevation} ${unit}`
    }


    return (
        processing || !group ?
            <Spinner /> :
            (
                <React.Fragment>
                    <div className="row justify-content-center ml-0 mr-0">
                       
                        <div className="event-card-view col-12">
                            <div className="row justify-content-center">
                                <div className="card mt-4">
                           
                                    <div className="card-header">
                                        <h2 className="" title={event.name}>{event.name}</h2>
                                        <span className="text-muted">
                                            Hosted for <Link to={"/groups/" + event.groupId}>{group.name}</Link> on the route - <Link to={"/routes/" + event.routes[0].id}>{event.routes[0].name}</Link>
                                        </span>
                                    </div>
                                    {event.cancelled ?
                                        (
                                            <div className="alert alert-danger" role="alert">
                                                {`This event was cancelled on ${moment(event.cancelledOn).format("DD/MM/YY")}`} {event.cancellationReason ? ` for the following reason: ${event.cancellationReason}` : ""}
                                            </div>
                                        )
                                        : ""}
                                    <div className="event-image-links">
                                        <Link className="event-group-avatarbox" title={group.name} to={"/groups/" + event.groupId}>
                                            {event.groupHasAvatar ?
                                                <UserAvatar className="event-group-avatar lrg" size="100" name={`${event.groupName}`} src={`${apiConfig.API_URL}groups/avatar/${event.groupId}.png`} />
                                                :
                                                <div className="event-group-avatar default lrg"><span className="fas fa-users" /></div>
                                            }
                                        </Link>
                                        <Link to={"/routes/" + event.routes[0].id} title={event.routes[0].name}>
                                            <img className="card-img-top img-fluid" src={`${apiConfig.API_URL}routes/routepreview/${event.routes[0].id}.png?size=lrg`} alt="Card image cap" />
                                        </Link>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-2">
                                            <div className="calendar-date">
                                                <div className="calendar-date-day">
                                                    { moment(event.startDate).format("dddd") }
                                                </div>
                                                <div className="calendar-date-month">
                                                    {moment(event.startDate).format("MMM")}
                                                </div>
                                                <div className="calendar-date-date">
                                                    {moment(event.startDate).format("DD")}
                                                </div>
                                            </div>
                                            <ul className="event-details">
                                                <li><img className="event-route-category" src={getRouteCategoryBadge(event.routes[0].category)} alt={event.routes[0].category} /> {` Distance: ${getRouteDistance()}, elevation: ${getRouteElevation()}`}</li>
                                                <li><span className={'fas fa-map-marker-alt'}></span> {event.location}</li>
                                                <li><span className={'fas fa-clock'}></span> {`Starts: ${moment(event.startDate).format("hh:mm a")}, finishes: ${moment(event.startDate).isSame(moment(event.finishDate), 'day') ? moment(event.finishDate).format("hh:mm a") : moment(event.finishDate).format("DD MMM, hh:mm a")}`} </li>
                                            </ul>
                                        </div>
                                        <div className="row">
                                        
                                            <hr />
                                            <div className="col-12 mb-3">
                                                <div className="event-participants-title"><strong>Participation</strong></div>
                                                {!event.cancelled ?
                                                    <div className="event-participants-response btn-group btn-group-sm" role="group" aria-label="Response">
                                                        <button type="button" value="0" onClick={handleSetStaus} disabled={event.organiser.userId.toUpperCase() == user.id.toUpperCase() ? true : false}
                                                            className={viewerParticipationStatus == 0 ? "btn btn-sm btn-primary" : "btn btn-sm btn-outline-secondary"}>Going</button>
                                                        {event.organiser.userId.toUpperCase() != user.id.toUpperCase() ?
                                                            <React.Fragment>
                                                                <button type="button" value="1" onClick={handleSetStaus} className={viewerParticipationStatus == 1 ? "btn btn-sm btn-primary" : "btn btn-sm btn-outline-secondary"}>Maybe</button>
                                                                <button type="button" value="2" onClick={handleSetStaus} className={viewerParticipationStatus == 2 ? "btn btn-sm btn-primary" : "btn btn-sm btn-outline-secondary"}>Can't Go</button>
                                                            </React.Fragment>
                                                                : ""}
                                                    </div>
                                                    : "" }
                                            </div>
                                        </div>
                                        <div className="row">
                                            <ul className="event-participants">
                                                {event.participants.map(eventUser => {
                                                    if (eventUser.status <= 1) {
                                                        return (
                                                            <li key={eventUser.userId} className="event-participant" title={`${eventUser.firstName} ${eventUser.surname}`} >
                                                                {(user.id && user.id.toUpperCase() == eventUser.userId.toUpperCase()) ?
                                                                    <UserAvatar className="event-participant-avatar" size="50" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                                                    :
                                                                    <UserAvatar className="event-participant-avatar" size="50" name={`${eventUser.firstName} ${eventUser.surname}`} src={eventUser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${eventUser.userId}.png` : ""} />
                                                                }
                                                                <div className={eventUser.status == 0 ? "response going" : "response maybe"}><span className={eventUser.status == 0 ? "fas fa-check" : "fas fa-question" }></span></div>
                                                            </li>
                                                        );
                                                    }
                                                })}
                                            </ul>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 mt-3 event-paticipant-details">
                                                <div className="event-paticipant-counters">{`${participationDetails.going.length} Going | ${participationDetails.maybe.length} Maybe | `}</div><button className="btn btn-link" data-toggle="modal" data-target="#participantsDetail">See All</button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <hr />
                                            <span className="card-title col-12"><strong>Description</strong></span>
                                            <div className="col-12 event-description">
                                                {event.description}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <div className="card-footer-avatar">
                                            {(user.id && user.id.toUpperCase() == event.organiser.userId.toUpperCase()) ?
                                                <UserAvatar size="30" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                                :
                                                <UserAvatar size="30" name={`${event.organiser.firstName} ${event.organiser.surname}`} src={event.organiser.hasAvatar ? `${apiConfig.API_URL}user/avatar/${event.organiser.userId}.png` : ""} />
                                            }
                                        </div>
                                        <ul>
                                            <li className="text-muted">{`Hosted by ${event.organiser.firstName} ${event.organiser.surname}`}</li>
                                            <li className="text-muted"> {`on ${moment(event.dateCreated).format("DD/MM/YYYY")}`}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <PostFeedControl mode={"Event"} refId={event.id} />
                    <div className="modal fade" id="editEvent" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Event</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <EventForm
                                        event={eventDetails}
                                        groups={ null }
                                        routes={ getRoutes() }
                                        onChange={handleChange}
                                        onSave={handleSave}
                                        onCancel={handleCancelSave}
                                        saving={processing}
                                        errors={errors}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="confirmCancelEvent" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" >{event.cancelled ? 'Update Cancellation' : 'Cancel Event?'}</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <EventCancellationForm
                                        event={eventDetails}
                                        errors={errors}
                                        onChange={handleChange}
                                        onSave={handleCancelEvent}
                                        onCancel={handleCloseConfirmCancel}
                                        processing={processing}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="confirmDeleteEvent" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" >Delete Event?</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    Are you sure that you want to delete this event?
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-dismiss="modal">No</button>
                                    <button type="button" className="btn btn-primary" onClick={onDeleteEvent}>Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="participantsDetail" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" >Participants</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <EventParticipationControl participants={participationDetails} loading={processing} />
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-primary" data-dismiss="modal">OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            )

    );

}
//disabled={event.organiser.userId.toUpperCase() == user.id.toUpperCase() ? "true" : "false"}

EventPage.propTypes = {
    setupNavigation: PropTypes.func.isRequired,
    loadEvent: PropTypes.func.isRequired,
    editEvent: PropTypes.func.isRequired,
    cancelEvent: PropTypes.func.isRequired,
    deleteEvent: PropTypes.func.isRequired,
    updateUserParticipation: PropTypes.func.isRequired,
    loadGroup: PropTypes.func.isRequired,
    eventId: PropTypes.number,
    groups: PropTypes.object.isRequired,
    events: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired
}


function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    return {
        eventId: parseInt(id),
        groups: state.groups,
        user: state.user,
        events: state.events
    };
}

const mapDispatchToProps = {
    setupNavigation,
    loadEvent,
    editEvent,
    cancelEvent,
    deleteEvent,
    updateUserParticipation,
    loadGroup
}

export default connect(mapStateToProps, mapDispatchToProps)(EventPage); 


// WEBPACK FOOTER //
// ./src/components/events/EventPage.js